export default __webpack_public_path__ + "static/bg-follow-us-74e52bb4866efb7f9852e7f69b597ef1.svg";